function ArrowRight({ className, isYellow }: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={`h-5 w-5 ${className}`}
      stroke={`${isYellow ? "#ebdd86" : "#b4b4b4"} `}
      fill="currentColor"
    >
      <path
        d="M4 12H20M20 12L16 8M20 12L16 16"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default ArrowRight;
